import { RelodeApiError, SuccessAction } from "@relode/core";
import {
    ActionsUnion,
    createAction,
    createMetaAction,
} from "@relode/core/components/reducer/actionHelpers";

import { SearchCriteria, SearchResults } from "./candidateSearchState";

export enum names {
    SEARCH = "SEARCH",
    SEARCH_SUCCESS = "SEARCH_SUCCESS",
    SEARCH_ERROR = "SEARCH_ERROR",
    SORT = "SORT",
    SORT_MOBILE = "SORT_MOBILE",
    NAVIGATE_NEXT = "NAVIGATE_NEXT",
    NAVIGATE_PREV = "NAVIGATE_PREV",
    SEARCH_BY_TEXT = "SEARCH_BY_TEXT",
    FILTER_SINGLE = "FILTER_SINGLE",
    FILTER_MULTIPLE = "FILTER_MULTIPLE",
    FILTER_BY_SELECTED_CRITERIA = "FILTER_BY_SELECTED_CRITERIA",
    MANAGE_CANDIDATE_FEEDBACK = "MANAGE_CANDIDATE_FEEDBACK",
    MANAGE_CANDIDATE_FEEDBACK_SUCCESS = "MANAGE_CANDIDATE_FEEDBACK_SUCCESS",
    MANAGE_CANDIDATE_FEEDBACK_FAILURE = "MANAGE_CANDIDATE_FEEDBACK_FAILURE",
    CLEAR_ERRORS = "CLEAR_ERRORS",
}

export default names;

export const creators = {
    search: (criteria: SearchCriteria) =>
        createAction(names.SEARCH, { criteria }),
    searchSuccess: (results: SearchResults) =>
        createAction(names.SEARCH_SUCCESS, {
            results,
        }),
    searchFailure: (apiError: RelodeApiError) =>
        createAction(names.SEARCH_ERROR, { apiError }),
    sort: (field: string) => createAction(names.SORT, { field }),
    sortMobile: (field: string, direction: SortDir) =>
        createAction(names.SORT_MOBILE, { field, direction }),
    navigateNext: (totalResults: number) =>
        createAction(names.NAVIGATE_NEXT, { totalResults }),
    navigatePrev: () => createAction(names.NAVIGATE_PREV),
    searchText: (searchText: string) =>
        createAction(names.SEARCH_BY_TEXT, {
            searchText,
        }),
    filterSingle: (
        id: string,
        name: string,
        item?: { label: string; value: string }
    ) => createAction(names.FILTER_SINGLE, { id, name, item }),
    filterMultiple: (
        id: string,
        name: string,
        category?: string,
        item?: { label: string; value: string }
    ) => createAction(names.FILTER_MULTIPLE, { id, name, category, item }),
    filterBySelectedCriteria: (searchText: string) =>
        createAction(names.FILTER_BY_SELECTED_CRITERIA, { searchText }),
    manageCandidateFeedback: () =>
        createAction(names.MANAGE_CANDIDATE_FEEDBACK),
    manageCandidateFeedbackSuccess: (
        message: string,
        jobId: number,
        leadId: number,
        vote: boolean,
        comment: string
    ) =>
        createMetaAction(
            names.MANAGE_CANDIDATE_FEEDBACK_SUCCESS,
            new SuccessAction(message),
            { jobId, leadId, vote, comment }
        ),
    manageCandidateFeedbackFailure: (apiError: RelodeApiError) =>
        createAction(names.MANAGE_CANDIDATE_FEEDBACK_FAILURE, { apiError }),
    clearErrors: () => createAction(names.CLEAR_ERRORS),
};

export type CandidateSearchActionTypes = ActionsUnion<typeof creators>;
